module.exports = __webpack_public_path__ + "img/code-2021-7.ca014bfa.png";